var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zahnarztPraxisWrap page"},[_c('div',{staticClass:"mb-5"},[_c('ZahnarztPraxis',{attrs:{"id":parseInt(_vm.id)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }